(() => {
  const recent = [...document.querySelectorAll('.bom-example')];
  const more = document.querySelector('[data-bom-more-boxes]');
  if (more && recent.length > 4) {
    const narrow = matchMedia('(max-width: 680px)');
    let expanded = false;
    const updateRecent = () => {
      recent.forEach((box, index) => { box.hidden = narrow.matches && !expanded && index >= 4; });
      more.hidden = !narrow.matches;
      more.setAttribute('aria-expanded', String(expanded));
      more.textContent = expanded ? 'Show fewer boxes' : `Show all ${recent.length} boxes`;
    };
    more.addEventListener('click', () => {
      expanded = !expanded;
      updateRecent();
    });
    narrow.addEventListener('change', updateRecent);
    updateRecent();
  }
  const years = [...document.querySelectorAll('.bom-year')];
  const filter = document.querySelector('#bom-year-filter');
  const tools = document.querySelector('[data-bom-archive-tools]');
  const status = document.querySelector('[data-bom-archive-status]');
  const nav = document.querySelector('.bom-year-nav');
  if (years.length && filter && tools && nav) {
    const yearOf = (group) => group.querySelector('h3').id.match(/bom-year-(\d{4})/)[1];
    const available = [...new Set(years.map(yearOf))].sort().reverse();
    available.forEach((year) => filter.add(new Option(year, year)));
    nav.replaceChildren(...available.map((year) => {
      const link = document.createElement('a');
      link.href = `#bom-year-${year}`;
      link.textContent = year;
      return link;
    }));
    const applyYear = (value) => {
      filter.value = available.includes(value) ? value : 'all';
      years.forEach((group) => { group.hidden = filter.value !== 'all' && yearOf(group) !== filter.value; });
      document.querySelectorAll('.bom-archive--legacy').forEach((archive) => {
        archive.hidden = ![...archive.querySelectorAll('.bom-year')].some((group) => !group.hidden);
      });
      const count = years.filter((group) => !group.hidden).reduce((total, group) => total + group.querySelectorAll('.bom-archive__item').length, 0);
      status.textContent = `${count} past boxes${filter.value === 'all' ? ' across all years' : ` in ${filter.value}`}`;
      nav.querySelectorAll('a').forEach((link) => {
        if (link.textContent === filter.value) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    const followYear = (id, focus) => {
      const target = document.getElementById(id);
      const year = id.match(/^bom-year-(\d{4})/);
      if (!target || !year) return;
      applyYear(year[1]);
      if (focus) {
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'start' });
      }
    };
    filter.addEventListener('change', () => applyYear(filter.value));
    nav.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      history.replaceState(null, '', link.hash);
      followYear(link.hash.slice(1), true);
    });
    document.querySelector('[data-bom-collapse]').addEventListener('click', () => {
      years.filter((group) => !group.hidden).forEach((group) => group.querySelectorAll('details[open]').forEach((item) => { item.open = false; }));
    });
    tools.hidden = false;
    tools.closest('.bom-archive').classList.add('bom-archive--filtered');
    applyYear(available[0]);
    followYear(location.hash.slice(1), false);
    addEventListener('hashchange', () => followYear(location.hash.slice(1), true));
  }

  // Give page jumps a visible destination under the site's sticky header.
  document.querySelectorAll('.bom-club a[href^="#"], .bom-sticky a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      // The theme's delegated smooth-scroll handler otherwise overrides this offset.
      event.stopPropagation();
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start' });
      history.replaceState(null, '', link.hash);
    });
  });

  const hero = document.querySelector('.bom-hero');
  const plans = document.querySelector('#bom-plans');
  const sticky = document.querySelector('[data-bom-sticky]');
  const finish = document.querySelector('.bom-finish');
  if (!hero || !plans || !sticky) return;

  const firstBox = document.querySelector('[data-bom-first-box]');
  if (firstBox) {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'
      }).formatToParts(new Date());
      const number = (type) => Number(parts.find((part) => part.type === type).value);
      const offset = number('day') > 24 ? 1 : 0;
      const month = new Date(Date.UTC(number('year'), number('month') - 1 + offset, 1));
      const label = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(month);
      firstBox.textContent = `Your first box is expected to begin shipping around the 24th or 25th of ${label}. Shipping dates are estimates.`;
    } catch (_) { /* Keep the cutoff guidance in the HTML if date formatting is unavailable. */ }
  }

  const update = () => {
    const mobile = window.matchMedia('(max-width: 680px)').matches;
    const heroBottom = hero.getBoundingClientRect().bottom;
    const planRect = plans.getBoundingClientRect();
    const finishTop = finish ? finish.getBoundingClientRect().top : Infinity;
    const focused = document.activeElement;
    const contentFocused = focused && focused !== document.body && !sticky.contains(focused) && focused.closest('main');
    sticky.hidden = !(mobile && !contentFocused && heroBottom < 0 && planRect.bottom < 0 && finishTop > window.innerHeight);
  };
  addEventListener('scroll', update, { passive: true });
  addEventListener('resize', update, { passive: true });
  addEventListener('focusin', update);
  addEventListener('focusout', () => requestAnimationFrame(update));
  update();
})();
